export default function PlayerCardSkeleton() {
	return (
		<div className="mr-2 flex h-fit min-w-[160px] animate-pulse flex-col items-center gap-2 rounded-lg border border-violet-200 bg-violet-25 p-2 shadow-lg">
			<div className="size-12 rounded-full bg-gray-200" />
			<div className="h-5 w-24 rounded bg-gray-200" />
			<div className="h-4 w-20 rounded bg-gray-200" />
			<div className="flex gap-2">
				<div className="h-4 w-12 rounded bg-gray-200" />
				<div className="h-4 w-12 rounded bg-gray-200" />
			</div>
		</div>
	);
}
